<template>
    <div id="app">

        <header class="header">
            <div class="container">

                <user-menu></user-menu>

            </div>
        </header>

        <div class="content content-outer">
            <div class="container">

                <router-view/>

            </div>
        </div>

        <main-footer></main-footer>

    </div>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'app',
        methods: {},
        beforeCreate() {
            this.$api.initFirebase()
            this.$api.loadConfig()
        },
        watch: {
            // auto-save doc data whenever something changes
            // NB: when updating an initially empty/non-existent array property in doc.data,
            // must use Vue.set(this.docData, 'myArray', [...]) in order to make this fire!
            '$store.state.doc.data': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('docData watcher')
                    this.$api.debouncedSaveDoc()
                }
            }
        }
    })

</script>

<style lang="scss">

    /* base styles for app */
    @import '../sass/base';

    #app {
        display: flex;
        min-height: 100vh;
        flex-direction: column;

        > .content {
            flex: 1;
        }
    }

    .header {
        border-bottom: solid 2px #E9E9E9;
        padding-top: 10px;
        padding-bottom: 10px;

        .container {
            max-width: 1440px;
        }

        @media print {
            display: none;
        }
    }

    .help-link {
        background: transparent !important;
        color: $pink;
        font-weight: bold;
        border: solid 2px $pink;
        border-radius: 50%;
        padding: 0 8px;

        &:hover {
            color: lighten($pink, 15%);
            border-color: lighten($pink, 15%);
        }
    }

    .crumb-separator {
        color: #aaa;
        padding: 0 .25em;
    }

    .content-outer {
        position: relative;

        &:after {
            position: fixed;
            z-index: 0;
            background: #FDF4E8;
            content: '';
            display: block;
            border-radius: 50%;
            width: 340vh;
            height: 260vh;
            right: -130vh;
            top: 300px;
            @media print {
                background: transparent;
            }
        }

        > .container {
            position: relative;
            z-index: 1;
            @media(max-width: 767px) {
                padding-left: 0;
                padding-right: 0;
            }
        }
    }

    .btn-primary.disabled, .btn-primary:disabled {
        background-color: $blue;
        opacity: .5;
    }

    .btn:focus, .btn.focus {
        @include box-shadow(0 0 10px rgba(0, 0, 0, .1));
    }

    .btn-icon {
        svg.icon {
            fill: #fff;
        }
    }

    .btn-icon-small {
        @extend .btn-icon;
        border-radius: 50%;
        padding: 0;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;

        svg.icon {
            position: absolute;
            @include absolute-center;
            width: 16px;
            height: 16px;
        }
    }

    .show-line-breaks {
        white-space: pre-line;
    }

</style>
